import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./styles.scss";
import assets from "./blogAssets";
import { getBlogPosts } from "../../utils/contentful";
import loadingImg from "../../assets/blog/loading.svg";
import { renderTags } from '../../utils/renderTags';
import { createSlug, storeSlugToIdMapping } from "../../utils/helpers";

const BlogCard = () => {
    const [blogPosts, setBlogPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBlogPosts = async () => {
            setLoading(true);
            try {
                const posts = await getBlogPosts();
                setBlogPosts(posts);
            } catch (error) {
                console.error("Error fetching blog posts:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogPosts();
    }, []);

    if (loading) {
        return (
            <div className="container text-center py-5">
                <img src={loadingImg || assets.calendar} alt="Loading" className="loading-icon" />
                <p>Loading blog posts...</p>
            </div>
        );
    }

    return (
        <div className="container">
            <div className="row row-gap-4">
                {blogPosts.length > 0 ? (
                    blogPosts.map((post) => {
                        const { fields, sys } = post;
                        const imageUrl = fields.mainImage?.fields?.file?.url ? `https:${fields.mainImage.fields.file.url}` : assets.placeholder;
                        const authorImageUrl = fields.authorImage?.fields?.file?.url 
                            ? `https:${fields.authorImage.fields.file.url}` 
                            : assets.placeholder;
                        const titleSlug = createSlug(fields.blogTitle);
                        
                        storeSlugToIdMapping(titleSlug, sys.id);

                        return (
                            <div key={sys.id} className="col-12 col-md-6 col-lg-4 d-flex">
                                <Link 
                                    to={`/blog/${titleSlug}`} 
                                    className="blog-card text-decoration-none"
                                >
                                    <img 
                                        src={imageUrl} 
                                        alt={fields.blogTitle} 
                                        className="img-fluid" 
                                    />
                                    <div className="card-data">
                                        <div className="d-flex flex-wrap mb-2">
                                            {renderTags(fields.tag)}
                                        </div>
                                        <h3>{fields.blogTitle}</h3>
                                        <div className="BCDetails">
                                            <div className="">
                                                <img 
                                                    src={authorImageUrl} 
                                                    alt="" 
                                                    className="author-img"
                                                />
                                                <span>{fields.authorName || "Author"}</span>
                                            </div>
                                            <div className="break-line"></div>
                                            <div className="">
                                                <img src={assets.calendar} alt="" className="calendar" />
                                                <span>
                                                    {new Date(sys.createdAt).toLocaleDateString('en-US', {
                                                        day: '2-digit',
                                                        month: 'long',
                                                        year: 'numeric'
                                                    })}
                                                </span>
                                            </div>
                                        </div>
                                        <p className="blog-card-desc"> {fields.desc} </p>
                                    </div>
                                </Link>
                            </div>
                        );
                    })
                ) : (
                    <div className="col-12 text-center py-5">
                        <p>No blog posts found.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BlogCard;